import './ErrorToast.scss';

const ErrorToast = ({textArray}) => (
    <div className="error-toast">
        {textArray.map(text => (<p key={`text-${text.split(' ').join('')}`}>{text}</p>))}
    </div>
);

export default ErrorToast;
